module.exports = __webpack_public_path__ + "static/media/error-red.20988fe8.png";